import { missingVarError, readVarT } from '@execonline-inc/environment';
import { log } from '@execonline-inc/logging';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { Task } from 'taskarian';
import { loadOneTrust } from './Loader';
import { handleOneTrustLoadError, OneTrustError } from './Types';

// Staging sets the key to an empty string while it tests Osano, so treat empty as missing.
const requireKey = (key: string): Task<OneTrustError, string> =>
  key === '' ? Task.fail(missingVarError('VITE_ONE_TRUST_KEY')) : Task.succeed(key);

function OneTrustTooling() {
  useEffect(() => {
    Task.succeed<OneTrustError, string>('VITE_ONE_TRUST_KEY')
      .andThen(readVarT)
      .andThen(requireKey)
      .andThen(loadOneTrust)
      .fork(handleOneTrustLoadError, () => {
        log('OneTrust Loaded Successfully!', window.OneTrust);
      });
  });

  return <></>;
}

export default observer(OneTrustTooling);
